import React from "react";
import { Link, Switch } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../../api/module/httpClient";
import { Layout, Skeleton, Space } from "antd";
import ProgramCards from "../ProgramCards";
import { getUserFromId } from "../../../api";
import { PrivateRoute } from "../../../components";
import CallForFaculty from "./CallForFaculty";
import { INTERNAL_LINKS } from "../../../enum";

export default function CallForFacultyCards({ userProfile }) {

  const { data, isFetching } = useQuery({
    queryKey: ["CALL_FOR_FACULTY"],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate-programs/open-for-faculty`);

      return data;
    },
  });

  return (
    <div>
      <div style={{ padding: "1rem 0"}}>
        {isFetching ? (
          <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
            {Array.from({ length: 3}).fill(1).map((_, i) => (<Skeleton width={268} height={500} />))}
          </div>
        ) : (
          <div className='container-list-certificates'>
            {(data || []).map(program => <ProgramCards program={program} userProfile={userProfile} linkTo={`${INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_FACULTY}/${program.slug}`} isDashboard={false} />)}
          </div>
        )}
      </div>
    </div>
  );
}